import { createFileRoute } from '@tanstack/react-router';
import api from '@/api';
import { ArticleDetailScreen } from '@/common/ArticleDetailScreen';
import { toArticleDetail } from '@/posts/posts';

// The old site addressed study-helper news at /study-helper-news/<slug>, so we
// keep that URL working. The kind comes from the URL (not the viewer's role) so
// the link resolves to the same article regardless of who opens it.
export const Route = createFileRoute('/_app/study-helper-news/$slug')({
  component: StudyHelperNewsDetailScreen,
});

function StudyHelperNewsDetailScreen() {
  const { slug } = Route.useParams();
  const { data, isPending } = api.getPost.useQuery({
    path: { slug },
    query: { kind: 'study_helper_news' },
  });
  const article = data ? toArticleDetail(data) : undefined;

  return (
    <ArticleDetailScreen
      article={article}
      isLoading={isPending}
      backPath="/news"
      // Translation Needed
      notFoundMessage="News article not found"
    />
  );
}
